import { HierarchyContextProps, IHierarchyActionAddSingleReplacement } from "./interface";

/**
 * Adds a single replacement to the hierarchy context state.
 *
 * @param action - The action containing the single replacement to add
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state with the new single replacement
 */
export const hcr_addSingleReplacement = (
  action: IHierarchyActionAddSingleReplacement,
  state: HierarchyContextProps,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw `hierarchyContextReducer: ${action.operation}: Hierarchy not assigned yet`;
  if (state.hierarchy.singles.find((s) => s.airid === action.single.airid)) {
    return state;
  } else {
    return {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        singles: [...state.hierarchy.singles, action.single],
      },
    };
  }
};
